<mat-toolbar *ngIf="toolbarVisible">
  <mat-toolbar-row>
    <button mat-icon-button class="menu-button" (click)="onOpenMenu()">
      <mat-icon>menu</mat-icon>
    </button>

    <a class="logo" [routerLink]="['/']">
      <img src="assets/images/artoil-logo.png" alt="Logo" />
    </a>

    <app-material-tabs [tabs]="toolbarLinks"></app-material-tabs>

    <app-autocomplete
      [formControl]="toolbarSearchControl"
      [placeholder]="'general.actions.search' | translate"
      [options]="toolbarLinksOptions"
      displayField="label"
      [isSearch]="true"
    >
    </app-autocomplete>

    <div class="company-name">
      <mat-icon class="icon material-icons-outlined">home</mat-icon>
      <span class="value">{{ customer?.companyName }}</span>
    </div>

    <button class="logout" mat-icon-button [disableRipple]="true" (click)="onLogout()">
      <mat-icon>logout</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>
